import { useSelectedValueByVariableKey } from '@k3/core';

export const useIsKioskMode = () => {
  const viewmode = useSelectedValueByVariableKey('viewmode');
  if (!viewmode) {
    console.warn('viewmode missing');
  }
  return viewmode?.key === 'kiosk';
};
